"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JangleLogo = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var JagexLogo_1 = require("../../atoms/JagexLogo/JagexLogo");
var jangle_1 = require("../../styles/Jangle/jangle");
function JangleLogo() {
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
            backgroundColor: theme_1.theme.colors.primary,
            justifyContent: "flex-end",
            minWidth: [125, 125, 125, 125, 210, 360],
            height: "88px",
            pr: 5,
            transform: "skew(-" + jangle_1.JANGLE_DEGREES + "deg)",
            ml: "-25px"
        } },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: { transform: "skew(" + jangle_1.JANGLE_DEGREES + "deg)" } },
            theme_ui_1.jsx(JagexLogo_1.JagexLogo, { iconColor: theme_1.theme.colors.white, hideName: true, width: 44 }))));
}
exports.JangleLogo = JangleLogo;
;
